// eslint-disable-next-line import/no-extraneous-dependencies
import { BaseComponent, BElement } from 'utils/base-component'
import './index.scss'
import './_mobile-nav.scss'

require.context('./static', true, /\.svg|png$/)

/**
 * Adds the 'active' class to navigation links that match the current page URL
 * Can be called on page load to highlight the current navigation item
 */
export function activeNav(): void {
  // Get the current path from the window location
  const currentPath = window.location.pathname

  // Select all navigation links in the page header
  const navLinks = document.querySelectorAll('.page-header__bot-container a')

  // Loop through each link and check if it matches the current path
  navLinks.forEach((link) => {
    const href = link.getAttribute('href')

    // Skip links without href or with just "#" href
    if (!href || href === '#') return

    // Check for exact match
    if (href === currentPath) {
      link.classList.add('active')
    }
    // Check for sub-path match (for sections)
    else if (href !== '/' && currentPath.startsWith(href)) {
      link.classList.add('active')
    }
    // Special case for home page
    else if (href === '/' && currentPath === '/') {
      link.classList.add('active')
    }
  })
}

export class PageHeader extends BaseComponent {
  static cssClass = 'page-header'

  private userBtn!: BElement
  private userNav!: BElement
  private menuBtn!: BElement
  private menuNav!: BElement
  private unitSwitcher!: BElement

  // Helper method to close all mobile menus with an optional exception
  private closeAllMobileMenus(exceptMenu?: BElement): void {
    const menus = [this.userNav, this.menuNav]

    menus.forEach((menu) => {
      // Skip this menu if it's the exception
      if (exceptMenu && menu === exceptMenu) return

      if (menu && menu.element) {
        const menuElement = menu.element
        menuElement.style.display = 'none'
      }
    })
  }

  // Helper method to toggle a specific menu
  private toggleMenu(menu: BElement, displayType: string = 'block'): void {
    if (!menu || !menu.element) return

    const menuElement = menu.element
    const currentDisplay = menu.element.style.display
    // Check if this menu is already visible
    const isVisible = currentDisplay !== 'none' && currentDisplay !== ''

    // For all other menus
    if (isVisible) {
      // Simply hide this menu if it's already visible
      menuElement.style.display = 'none'
    } else {
      // Close all menus first
      this.closeAllMobileMenus()
      // Then show this menu
      menuElement.style.display = displayType
    }
  }

  init() {
    // Call activeNav function to highlight the current navigation item
    activeNav()

    // Initialize elements for user Nav, menu Nav, and channel Navs
    const mobileUserBtn = document.querySelector('.mobile-nav__link--user')
    this.userBtn = new BElement(mobileUserBtn, this.cssClass)

    const mobileUserNav = document.querySelector('.mobile-nav__user-nav-container')
    this.userNav = new BElement(mobileUserNav, this.cssClass)

    const mobileMenuBtn = document.querySelector('.mobile-nav__link--menu')
    this.menuBtn = new BElement(mobileMenuBtn, this.cssClass)

    const mobileMenuNav = document.querySelector('.mobile-nav__menu-nav-container')
    this.menuNav = new BElement(mobileMenuNav, this.cssClass)

    const mobUnitSwitcher = document.querySelector('.switch-units-selector')
    this.unitSwitcher = new BElement(mobUnitSwitcher, this.cssClass)

    // Add click event listeners to toggle display
    this.userBtn.element.addEventListener('click', (e) => {
      e.preventDefault()
      this.toggleMenu(this.userNav, 'block')
    })

    this.menuBtn.element.addEventListener('click', (e) => {
      e.preventDefault()
      this.toggleMenu(this.menuNav, 'block')
    })

    // Add window resize event listener to hide menus when screen is resized to 768px or more
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 768) {
        // Hide all mobile menus when viewport is 768px or larger
        this.closeAllMobileMenus()
      }
    })

    // Add click event listener to document to close menus when clicking outside the menus
    document.addEventListener('click', (e) => {
      // Skip this handler if the click came from a button to avoid race conditions
      if (
        e.target instanceof Node &&
        (this.userBtn.element.contains(e.target) || this.menuBtn.element.contains(e.target))
      ) {
        return
      }
      // Check if click target is inside any of our menus or toggle buttons
      const isMenuClick =
        e.target instanceof Node &&
        (this.userNav.element.contains(e.target) ||
          this.menuNav.element.contains(e.target) ||
          this.unitSwitcher.element.contains(e.target))

      // If click is outside all menus, close them all
      if (!isMenuClick) {
        this.closeAllMobileMenus()
      }
    })
  }
}
